/*
* Copyright(c) 2018. Synergy Systems & Solutions. @link : http://s3india.com 
*
* @module : QuizEnd
* @file : QuizEnd.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of QuizEnd
*
* Created on : 16-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 18-Oct-2019
*/
import React from 'react';
import Translation from '../../language/Translation';

class QuizEnd extends React.Component
{
	constructor(props)
	{
		super(props);
		this.translation = new Translation();
		this.state = {
			translation:{
				'quiz_end_v1':this.translation.getText('quiz_end_v1'),
				'quiz_end_v2':this.translation.getText('quiz_end_v2'),
				'quiz_end_v3':this.translation.getText('quiz_end_v3'),
				'quiz_end_v4':this.translation.getText('quiz_end_v4'),
			}
		}

	}

	componentDidMount()
	{

	}

	render()
	{
		return (
			<React.Fragment>
			<div className="content-box-area">
				<div className="default-heading">
				<h2>{this.state.translation.quiz_end_v1}</h2>
				<h2>{this.state.translation.quiz_end_v2}</h2>
				</div>
				<div className="paragraph-area text-center">
				<p>{this.state.translation.quiz_end_v3} <a href="https://www.biovision.ch/wissen-schafft-nahrung?utm_source=quiz&utm_medium=webapp&utm_campaign=herbstkampagne&utm_term=quiz-ende-mehr-info">{this.state.translation.quiz_end_v4}</a></p>
				</div>
				<div className="text-center buttons-area">
				</div>
				</div>
			</React.Fragment>
		)
	}
}

export default QuizEnd;